import type { Role } from '../../pages/users/types/rbac';

const SUPERVISION_EDIT_ROLES: readonly Role[] = [
  'practice-admin',
  'practice-owner',
  'unify-admin',
] as const;

/**
 * Returns true when the current user may edit supervision relationships.
 * Admin-like roles win when a user also holds Provider or Supervisor roles.
 */
export function canEditSupervisionRelationships(currentUserRoles: Role[]): boolean {
  return currentUserRoles.some((role) =>
    (SUPERVISION_EDIT_ROLES as readonly string[]).includes(role),
  );
}
